import { useCallback } from 'react';
import uuid from 'react-uuid';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import Button, { isButtonDisabled } from 'src/components/design-system/Button';
import PopUp from 'src/components/design-system/PopUp';
import { InvoiceLineItem } from 'src/services/useInvoiceLineItemsApi';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from './InvoiceDetailsContext';
import useInvoiceButtonState from './useInvoiceButtonState';

const AddLineItem = () => {
  const isInvoiceEditDisabled = useContextSelector(
    InvoiceContext,
    (value) => value.isInvoiceEditDisabled
  );
  const setInvoiceLineItems = useContextSelector(
    InvoiceContext,
    (value) => value.setInvoiceLineItems
  );
  const setIsLineItemClick = useContextSelector(
    InvoiceContext,
    (value) => value.setIsLineItemClick
  );

  const handleAddLineItem = useCallback(() => {
    setInvoiceLineItems((prev) => [
      ...prev,
      {
        canDelete: 0,
        isTaxable: true,
        description: '',
        glCd: '',
        poQty: 0,
        quantityReceived: 1,
        priceAmt: 0,
        uom: 'EA',
        rowId: uuid(),
        subTotal: 0,
        productItemNum: '',
        isNewLineItem: true,
        isNewlyAddedLineItemNow: true,
        completed: 'N',
        receiptLineItemId: Number(`${parseInt(String(Math.random() * 100000))}987654321`),
      } as unknown as InvoiceLineItem,
    ]);
    setIsLineItemClick(true);
  }, [setInvoiceLineItems, setIsLineItemClick]);

  const [message, buttonState] = useInvoiceButtonState('AddLineItem');

  return (
    <PopUp
      content={
        <div className="m-1 max-w-[300px]">
          <PopUpContentWrapper
            type="Information"
            contents={[
              ...(isInvoiceEditDisabled ? ['Current document cannot be updated'] : []),
              ...(isButtonDisabled(buttonState) ? message : []),
            ]}
          />
        </div>
      }
      show={isInvoiceEditDisabled || isButtonDisabled(buttonState)}
    >
      <Button
        onClick={handleAddLineItem}
        disabled={isInvoiceEditDisabled}
        buttonState={buttonState}
        id="add_line_item_button"
      >
        Add Line Item
      </Button>
    </PopUp>
  );
};

export default AddLineItem;
